import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import React from "react";

import { formatTime } from "../../utils/generalFunctions";
import NonverbalBadge from "./NonverbalBadge.js";
import { HELD_BACK_TEXT, dubStatus, nonverbalOf } from "./nonverbal.js";

// Regions non-verbal detection was less sure of. They are in the dub unless
// rejected, except ones held back (over original speech, say), which wait
// for a user to accept them.
const NonverbalSuggestions = ({ suggestions, onReview, onSeek, busyId = null }) => {
    if (!suggestions.length) {
        return null;
    }
    return (
        <Box marginTop={2} marginBottom={2} marginLeft={1} data-testid="nonverbal-suggestions">
            <Typography variant="subtitle1" fontWeight={600}>
                Suggested non-verbal sounds ({suggestions.length})
            </Typography>
            <Typography variant="body2" color="text.secondary" marginBottom={1}>
                In the dub unless you reject them. Ones marked "Needs your OK" stay out until
                you accept them.
            </Typography>
            <Stack spacing={1}>
                {suggestions.map((region) => (
                    <Stack
                        key={region.dbid}
                        direction="row"
                        spacing={1.5}
                        alignItems="center"
                    >
                        <Typography
                            variant="body2"
                            sx={{ cursor: "pointer", minWidth: 190 }}
                            onClick={() => onSeek?.(region.start)}
                        >
                            {formatTime(region.start)} – {formatTime(region.end)}
                        </Typography>
                        <NonverbalBadge item={region} />
                        {dubStatus(region) === "held" ? (
                            <Chip
                                size="small"
                                color="primary"
                                variant="outlined"
                                label="Needs your OK"
                                title={HELD_BACK_TEXT[nonverbalOf(region).heldBack] || ""}
                            />
                        ) : (
                            <Chip size="small" color="success" variant="outlined" label="In the dub" />
                        )}
                        <Typography variant="body2" sx={{ flexGrow: 1 }}>
                            {region.description}
                        </Typography>
                        <Button
                            size="small"
                            variant="contained"
                            disabled={busyId === region.dbid}
                            onClick={() => onReview(region, "accept")}
                        >
                            Accept
                        </Button>
                        <Button
                            size="small"
                            color="error"
                            disabled={busyId === region.dbid}
                            onClick={() => onReview(region, "reject")}
                        >
                            Reject
                        </Button>
                    </Stack>
                ))}
            </Stack>
        </Box>
    );
};

export default NonverbalSuggestions;
